import React from 'react';
import { Collapse } from 'components/Collapse/Collapse';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { ReactComponent as BlueChevronDown } from 'style/_assets/icons/blue-chevron-down.svg';
import { ReactComponent as BlueChevronUp } from 'style/_assets/icons/blue-chevron-up.svg';
import './OffersTrayCollapse.scss';
import { useEventHandler } from 'hook/event.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';

const BonusOfferSection = props => {
  const { offerMetadata, key, setIsCollapseOpen, isCollapseOpen } = props;
  const clickType = isCollapseOpen ? 'Close Bonus Tray' : 'Open Bonus Tray';
  const eventHandler = useEventHandler();

  return (
    <FlexContainer
      className={`margTAuto ${props?.className}`}
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <Collapse
        expandIconPosition={props?.expandIconPosition}
        className={props?.collapseContainerShadow}
        expandIcon={({ isActive }) =>
          isActive ? <BlueChevronUp /> : <BlueChevronDown />
        }
        onChange={() => {
          setIsCollapseOpen(!isCollapseOpen);
          eventHandler(CLICK, {
            'Click Type': clickType,
          });
        }}
        activeKey={isCollapseOpen ? `${key}` : null}
        panels={[
          {
            header: offerMetadata?.bonusOfferInfo?.bonusOfferName,
            content: props?.offerContent(),
            extra: props?.genExtra(),
            key: `${key}`,
          },
        ]}
      />
    </FlexContainer>
  );
};

export { BonusOfferSection as OffersTray };
